<template lang="html">

  <div class="wrapper -empresas">

    <div class="encabezado">
  
      <div class="container column-start">
        <div class="contenedor-logo">
          <router-link to="/">
            <img src="/static/img/UFV-logo.png" alt="Logo UFV">
          </router-link>
        </div>
        <h1>Preguntas frecuentes</h1>
      </div>

    </div>
    <nav class="breadcrumb row-start container">
      <a href="">Home</a>
      <a href="">Preguntas frecuentes</a>
    </nav>

    <section class="faqs-container container">

      <article class="faq" v-for="n in 10">
        <h2>Asunto</h2>
        <div class="contenedor-faq">
          <h3>Pregunta</h3>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores fugit recusandae, velit quam eos suscipit ex a deleniti provident quod ullam quis alias voluptates cupiditate, facere unde corrupti. Quae, perferendis!</p>

          <h3>Pregunta</h3>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores fugit recusandae, velit quam eos suscipit ex a deleniti provident quod ullam quis alias voluptates cupiditate, facere unde corrupti. Quae, perferendis!</p>

          <h3>Pregunta</h3>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores fugit recusandae, velit quam eos suscipit ex a deleniti provident quod ullam quis alias voluptates cupiditate, facere unde corrupti. Quae, perferendis!</p>

        </div>
      </article>

    </section>

  </div>


</template>

<script lang="js">
  export default {
    name: 'faqs',

  }
</script>

<style scoped lang="scss">
  .encabezado h1 {
    max-width: 350px;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/faqs.vue